import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlags } from '../hooks/useFeatureFlags';
import { useRouterProps } from '../hooks/useRouterProps';
import { ROUTES } from '@lsgo/lsgo-common/constants/routes';

/**
 * Feature flag-based route guard
 * Only checks feature flags - authentication should be handled by RouteBuilder
 * This guard assumes auth has already been verified
 */
const FeatureFlagRoute = ({ children, render, flags = [], requireAll = false, redirectTo, fallback, ...props }) => {
    const featureFlagsHook = useFeatureFlags();
    const routerProps = useRouterProps();

    // Check feature flags (auth is handled by RouteBuilder)
    if (flags && flags.length > 0) {
        const hasFlags = requireAll
            ? featureFlagsHook.hasAllFeatureFlags(flags)
            : featureFlagsHook.hasAnyFeatureFlag(flags);

        if (!hasFlags) {
            return fallback || <Navigate to={redirectTo || ROUTES.AUTH.FEATURE_NOT_AVAILABLE.path} replace />;
        }
    }

    // All checks passed
    return render ? render({ ...props, ...routerProps }) : children;
};

export default FeatureFlagRoute;
